var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "boek" }, [
    _c(
      "div",
      { staticClass: "session-details-pick-a-date" },
      [
        _c("h4", [_vm._v("Beschikbaarheid")]),
        _vm._v(" "),
        _c("Datepicker", {
          attrs: {
            inline: true,
            language: _vm.language,
            "maximum-view": "day",
            "disabled-dates": {
              customPredictor: function (date) {
                return _vm.checkPredictor(date)
              },
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Agenda.vue